import React from "react";
import ModuleDetailDesktop from "./ModuleDetailDesktop";
import ModuleDetailMobile from "./ModuleDetailMobile";
import { FeatureModuleDetailType } from "../types/FeatureModuleDetail";

const FeatureModuleDetail = ({ feature, onClick }: FeatureModuleDetailType) => (
  <>
    <ModuleDetailDesktop feature={feature} onClick={onClick} />
    <ModuleDetailMobile feature={feature} onClick={onClick} />
  </>
);

export default FeatureModuleDetail;
